module.exports = __webpack_public_path__ + "img/gPay-Email.d24370a7.svg";